import type { GanttRow, GanttTask } from './gantt-types';

export const GANTTT_TASK_DND_TYPE = 'GANTT_TASK';

export interface GanttTaskDragObject {
  task: GanttTask;
  fromRow: GanttRow;
  initialScrollLeft: number;
}

export interface GanttTaskDropResult {
  toRow: GanttRow;
  move: { startDate: string; endDate: string };
  dropEffect: 'copy' | 'move';
}
